import type { IconSvgObject } from './types';

const ArrowMoveUpLeftIcon: IconSvgObject = [
  ["path", { d: "M20 21V8.00012C20 6.89556 19.1046 6.00013 18 6.00012L4 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3.00012L4 6.00012L7 9.00012", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowMoveUpLeftIcon;
